import { Button, Grid, TextField } from "@mui/material";
import GlobalDialogContent from "../GlobalDialogContent";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/reducer/snackbarSlice";
import { closeDialog } from "../../../redux/reducer/dialogSlice";
import { useSearchParams } from "react-router-dom";
import { RegisterEventService } from "../../../utils/services/project/project";
import { setModuleRefresh } from "../../../redux/reducer/registration/RefreshSlice";

const RegisterEvent = () => {
    const dispatch = useDispatch();
      const [searchParams] = useSearchParams();
    const uuid = searchParams.get("uuid");
    const formik = useFormik({
        initialValues: {
            fname: "",
            lname: "",
            contact: "",
            email: "",
            address: "",
        },
        validationSchema: Yup.object({
            fname: Yup.string().required("First Name is Required"),
            lname: Yup.string().required("Last Name is Required"),
            contact: Yup.string().matches(/^\d{10}$/, "Contact must be a 10-digit number").required("Mobile Number is Required"),
            email: Yup.string().email("Invalid email format").required("Email is Required"),
            address: Yup.string().min(5, "Address must be at least 5 characters").required("Address is Required"),
        }),
        onSubmit: async (values) => {
            const payload = {
                uuid: uuid,
                firstname: values?.fname,
                lastname: values?.lname,
                email: values?.email,
                mobile_no: values?.contact,
                address: values?.address
            }
            const { code, data, message } = await RegisterEventService(payload);
            if (code === 200) {
                dispatch(showSnackbar({ type: "success", message: message || 'Succesfully.' }));
                dispatch(closeDialog());
                dispatch(setModuleRefresh({ moduleName: 'register_event', refresh: true }));                
            } else {
                dispatch(showSnackbar({ type: "error", message: message || ' error.' }));

            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <GlobalDialogContent
                dialogBody={
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label="First Name *"
                                name="fname"
                                value={formik.values.fname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.fname && Boolean(formik.errors.fname)}
                                helperText={formik.touched.fname && formik.errors.fname}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label="Last Name *"
                                name="lname"
                                value={formik.values.lname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.lname && Boolean(formik.errors.lname)}
                                helperText={formik.touched.lname && formik.errors.lname}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label="Mobile Number *"
                                name="contact"
                                type="text"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                      formik.handleChange(e);
                                    }
                                  }}
                                inputProps={{ maxLength: 10}}
                                value={formik.values.contact}
                                onBlur={formik.handleBlur}
                                error={formik.touched.contact && Boolean(formik.errors.contact)}
                                helperText={formik.touched.contact && formik.errors.contact}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label="Email *"
                                name="email"
                                type="email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                size="small"
                                margin="normal"
                                label="Address *"
                                name="address"
                                multiline
                                rows={3}
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.address && Boolean(formik.errors.address)}
                                helperText={formik.touched.address && formik.errors.address}
                            />
                        </Grid>
                    </Grid>
                }
                dialogFooter={
                    <>
                        <>
                            <Button type="submit" variant="contained" color="success">
                                Submit
                            </Button>
                        </>
                    </>
                }
            />
        </form>
    );
};

export default RegisterEvent;
